"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ContainerHolder_1 = __importDefault(require("../Container/ContainerHolder"));
exports.default = (date) => {
    const container = ContainerHolder_1.default.getInstance();
    const dayOfWeek = container.get("SYSTEM_DATE_TIME_PROVIDER").dayOfWeek(date);
    return container.get("SYSTEM_DATE_TIME_MODIFIER" // TODO: it is only workaround for circulars
    ).modifyDays(date, 6 - dayOfWeek);
};
//# sourceMappingURL=endOfWeekAfter.js.map